import * as angular from "angular";

export class ElectionService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/election";
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all", data);
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/info/" + data.id, data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/delete/" + data.id, data);
    }
}

angular.module("vcServices").service("ElectionService", ElectionService);
